import React, { useState, useEffect } from "react";
import Select, { Option, OptionHeader } from "../library/Select";

const FavouriteSelect = ({ onChange, isApproved }) => {
  const [jobs, setJobs] = useState([]);

  const fetchJobs = () => {
    fetch(
        `${
          process.env.REACT_APP_API_ENDPOINT
        }/api/jobs/?name=`,
        {
          headers: {
            "x-access-token": localStorage.getItem("access_token"),
          },
        }
      )
        .then((res) => res.json())
        .then(setJobs)
        .catch((error) => console.error(error));      
  }

  useEffect(fetchJobs, []);

  const nonClientJobs = jobs.filter((job) => !job.jobId)
    .filter((j) => j.isFavourite);
  const clientJobs = jobs.filter((job) => !!job.jobId)
    .filter((j) => j.isFavourite);

  return (
    <Select
      dark
      searchable
      onChange={(newValue) => {
        onChange(
          newValue,
          jobs.find((job) => job.id === newValue),
          false
        );
      }}
      onOpen={fetchJobs}
      renderValue={"My Favourites"}
      disabled={isApproved}
      title={isApproved ? "Unable to add jobs to an approved day" : ""}
    >
      {nonClientJobs.length > 0 && <OptionHeader>Non-Client</OptionHeader>}
      {nonClientJobs
        .map((job) => (
          <Option key={job.id} value={job.id}>
            {`${job.jobId ?  `${job.jobId}: ${job.name}` : job.name}`}
          </Option>
        ))}
      {clientJobs.length > 0 && <OptionHeader>Native</OptionHeader>}
      {clientJobs
        .map((job) => (
          <Option key={job.id} value={job.id}>
            {`${job.jobId ?  `${job.jobId}: ${job.name}` : job.name}`}
          </Option>
        ))}
    </Select>
  );
};

export default FavouriteSelect;
